import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './VendorListItem';

import VendorActions from '../../actions/VendorActionCreator';
import VendorStore from '../../stores/VendorStore';

class VendorList extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            vendors: [],
            count: 0,
            page: 0,
            limit: 50,
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        VendorStore.addChangeListener(this.onChange);
        VendorActions.getAll({limit: this.state.limit});
    }

    componentWillUnmount() {
        VendorStore.removeChangeListener(this.onChange);
    }

    render() {

        const isAdmin = this.context.auth.isAdmin();
        let viewProps = {
            title:         'Vendors',
            items:         this.state.vendors,
            itemDecorator: ListItem,
        };
        if (isAdmin) {
            viewProps.newEntityUrl = '/dashboard/vendor/new';
        }
        
        return <ListView {...viewProps} />;
    }

    onChange() {
        const vendors = VendorStore.getAll({limit: this.state.limit});
        if (!!vendors) {
            this.setState({vendors: vendors});
        }
    }
}

VendorList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default VendorList;
